import { combineReducers } from '@reduxjs/toolkit'
import {
  accountsNotificationsCatalogReducers,
  accountsValidationsErrorsReducers,
  commonNotificationsCatalogReducers,
  commonValidationsErrorsReducers,
  mailboxNotificationsCatalogReducers,
  mailboxValidationsErrorsReducers,
  masterTableReducers,
  positionNotificationsCatalogReducers,
  positionValidationsErrorsReducers,
  toolsNotificationsCatalogReducers,
  toolsValidationsErrorsReducers,
  userNotificationsCatalogReducers,
  userValidationsErrorsReducers,
} from '../slices'

export const catalogsReducers = combineReducers({
  masterTables: combineReducers(masterTableReducers),
  notifications: combineReducers({
    accounts: accountsNotificationsCatalogReducers,
    position: positionNotificationsCatalogReducers,
    tools: toolsNotificationsCatalogReducers,
    common: commonNotificationsCatalogReducers,
    user: userNotificationsCatalogReducers,
    mailbox: mailboxNotificationsCatalogReducers,
  }),
  validationsErrors: combineReducers({
    accounts: accountsValidationsErrorsReducers,
    position: positionValidationsErrorsReducers,
    tools: toolsValidationsErrorsReducers,
    common: commonValidationsErrorsReducers,
    user: userValidationsErrorsReducers,
    mailbox: mailboxValidationsErrorsReducers,
  }),
})
